/**
 * API base URL from environment.
 * Set REACT_APP_API_BASE_URL in .env at project root (no trailing slash).
 * When REACT_APP_USE_PROXY=true (e.g. on Render), use '' so requests go to same origin and the server proxies to HTTP backends.
 */
const useProxy = process.env.REACT_APP_USE_PROXY === 'true';
const raw = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = useProxy ? '' : ((typeof raw === 'string' && raw.trim()) ? raw.trim() : 'http://localhost:8081');

/**
 * Risk Intelligence News Feed API paths (relative to /api/v1).
 * Base URL for news: `${API_BASE_URL}/api/v1/news`
 */
export const NEWS_API = {
  ARTICLES: '/articles',
  FILTERS: '/filters',
  QUICK_FILTER_COUNTS: '/quick-filter-counts',
  TRENDING_TOPICS: '/trending-topics',
  SAVE_ARTICLE: (articleId) => `/articles/${articleId}/save`,
  SAVED_ARTICLES: '/saved-articles',
};

export { API_BASE_URL };
